var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0835 11.25C1.76266 11.25 1.48801 11.1358 1.25954 10.9073C1.03107 10.6788 0.916829 10.4042 0.916829 10.0833V2.5H0.333496V1.33333H3.25016V0.75H6.75016V1.33333H9.66683V2.5H9.0835V10.0833C9.0835 10.4042 8.96926 10.6788 8.74079 10.9073C8.51232 11.1358 8.23766 11.25 7.91683 11.25H2.0835ZM7.91683 2.5H2.0835V10.0833H7.91683V2.5ZM3.25016 8.91667H4.41683V3.66667H3.25016V8.91667ZM5.5835 8.91667H6.75016V3.66667H5.5835V8.91667Z",
    fill: "#E63C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletered);
export default __webpack_public_path__ + "static/media/deletered.9e6ce749.svg";
export { ForwardRef as ReactComponent };